import { Options } from '@angular-slider/ngx-slider';
import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, ElementRef, HostListener, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormsModule, UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { BsModalRef, BsModalService, } from 'ngx-bootstrap/modal';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { BehaviorSubject, firstValueFrom, Subject, Subscription } from 'rxjs';
import { auditTime, debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { PricePlanService } from 'src/app/components/Price-subscritions/priceplanService';
import { CandidateVerticalFilterTemplateComponent } from "src/app/components/candidate-module/candidate-vertical-filter-template/candidate-vertical-filter-template.component";
import { JobInvitesFilterComponent } from "src/app/components/candidate-module/job-invites-filter/job-invites-filter.component";
import { JobsAppliedFilterComponent } from "src/app/components/candidate-module/jobs-applied-filter/jobs-applied-filter.component";
import { JobsCandidatesSlideFilterComponent } from "src/app/components/jobs-candidates-slide-filter/jobs-candidates-slide-filter.component";
import { CandidateService } from 'src/app/services/CandidateService';
import { GigsumoConstants, USER_TYPE } from 'src/app/services/GigsumoConstants';
import { ApiService } from 'src/app/services/api.service';
import { candidateModel } from 'src/app/services/candidateModel';
import { GigsumoService } from 'src/app/services/gigsumoService';
import { JobService } from 'src/app/services/job.service';
import { jobModuleConfig } from 'src/app/services/jobModuleConfig';
import { PageType } from 'src/app/services/pageTypes';
import { SearchData } from 'src/app/services/searchData';
import { CandidateFilterModel } from 'src/app/services/userModel';
import { filterConfig } from 'src/app/types/filterConfig';
import { CommunicationService } from 'src/shared/services/CommunicationService';
import { AppSettings } from 'src/app/services/AppSettings';
import { ConnectionTemplateComponent } from '../../../../templates/connection-template/connection-template.component';
import { TimezoneDatePipe } from '../../../../timezone-date.pipe';
import { CandidateFilterTemplateComponent } from '../../../../components/candidate-module/candidate-filter-template/candidate-filter-template.component';
import { CandidateJobInviteComponent } from '../../../../components/candidate-module/candidate-job-invite/candidate-job-invite.component';
import { CandidateLikeComponent } from '../../../../components/candidate-module/candidate-like/candidate-like.component';
import { CandidateProfileSummaryComponent } from '../../../../components/candidate-module/candidate-profile-summary/candidate-profile-summary.component';
import { CandidateRequestsReceivedComponent } from '../../../../components/candidate-module/candidate-requests-received/candidate-requests-received.component';
import { CandidateViewedByComponent } from '../../../../components/candidate-module/candidate-viewed-by/candidate-viewed-by.component';
import { CandidatesPageComponent } from '../../../../components/candidate-module/candidates-page/candidates-page.component';
import { CandidatesProfileDetailsComponent } from '../../../../components/candidate-module/candidates-profile-details/candidates-profile-details.component';
import { JobsAppliedcandidateComponent } from '../../../../components/job-module/jobs-applied/jobs-applied.component';
import { JobPublishtoComponent } from '../../../../components/job-publishto/job-publishto.component';
import { CommonValues } from '../../../../services/commonValues';
import { CommonSkeletonComponent } from '../../../../skeleton/common-skeleton/common-skeleton.component';
import { WidgetModule } from '../../../../widget/widget.module';
import { JobSubmitSkillfilterComponent } from '../../../../widget/job-submit-skillfilter/job-submit-skillfilter.component';
import { MessageWidgetComponent } from '../../../../widget/message-widget/message-widget.component';
import { CandidatePortfolioComponent } from '../candidate-portfolio/candidate-portfolio.component';
import { NG_ICON_DIRECTIVES } from '@ng-icons/core';

declare var $: any;

@Component({
  selector: 'app-new-candidate',
  standalone: true,
  imports: [CommonModule, FormsModule, InfiniteScrollModule, CandidatesPageComponent, CandidateLikeComponent, CandidateViewedByComponent, CandidateRequestsReceivedComponent, CandidateJobInviteComponent, CandidatesProfileDetailsComponent, CandidateProfileSummaryComponent, CandidatePortfolioComponent, CandidateFilterTemplateComponent, JobsAppliedcandidateComponent, JobPublishtoComponent, JobSubmitSkillfilterComponent, MessageWidgetComponent, WidgetModule, CommonSkeletonComponent,
JobsCandidatesSlideFilterComponent, JobsAppliedFilterComponent, JobInvitesFilterComponent, CandidateVerticalFilterTemplateComponent, ConnectionTemplateComponent, TimezoneDatePipe, BsDropdownModule,
    NG_ICON_DIRECTIVES,
  ],
  templateUrl: './new-candidate.component.html',
  styleUrls: ['./new-candidate.component.scss']
})
export class NewCandidateComponent implements OnInit, OnDestroy {
  @Input() jobData: any;
  @Input() focus: string;
  singleCandidateView: boolean = false;
  afterCandidateCreated: boolean = false;
  artificialAddNeeded: boolean = false;
  createdCandidateData: any = null;
  artificialInsertTimeout: any = null;
  response = new BehaviorSubject<any>([]);
  dataPass: any = [];
  stopscrollFlag: boolean = false
  entitySent: any = {}
  userType = localStorage.getItem('userType')
  designVersion: string = 'v3';
  url = AppSettings.ServerUrl + 'download/';
  jobfilter = false;
  totalFilters: number = 0;

  event: string = "CANDIDATE";
  candidateFoundStatus: any = ""
  dataPasstoSkillwidgets: Array<any> = [];
  removeSelected: any;
  FeaSugg: boolean = false
  activeStatus: boolean = null;
  removeTagvalues: any;
  stateListCA: any;
  stateListIN: any;
  stateListAU: any;
  candidateFilterForm: UntypedFormGroup;
  jobSeekerListName: string = "Profile";
  countryList: any = [];
  candidateSource: Array<any> = [];
  engagementType: any = [];
  status: any = [];
  filterApplied: boolean = false
  workAuthorization: any = [];
  activeIds = [];
  @ViewChild("lgModal") lgModal;
  @ViewChild('profileSummaryRef') profileSummaryRef: CandidateProfileSummaryComponent;
  // Reference to the left-panel <app-candidates-page> instance so the V3
  // detail-header More menu can delegate Republish / Upgrade / Downgrade
  // straight to its existing handlers — same pattern new-job uses for
  // jobsRef (new-job.component.ts:1910-1926).
  @ViewChild('candidatesRef') candidatesRef: CandidatesPageComponent;
  highValue2: number;
  refreshCandidates: Subscription
  filterReload: Subscription
  value: number = 0;
  highValue: number = 0;
  options: Options = {
    floor: 0,
    ceil: 50
  };

  value1: number = 0;
  highValue1: number = 0;
  options1: Options = {
    floor: 0,
    ceil: 99
  };
  owner: boolean = false;
  showsuggJobsData: any = [];
  formDataPost: any = {};
  keyarrayCandidatesouces = ["all", "marketPlaceCandidates", "myCandidates", "teamCandidates", "benchNetworkCandidates", "freeLancerNetworkCandidates", "mtaNetworkCandidates", "jobSeekerNetworkCandidates", "featured", "suggestedCandidates"];

  get candidateListLabel(): string {
    const activeSources = this.candidateSource.filter(s => this.keyarrayCandidatesouces.includes(s));
    if (activeSources.length === 1 && activeSources[0] === 'myCandidates') return 'My Candidates';
    if (activeSources.length > 0) return 'All Candidates';
    return 'Candidates';
  }
  keysarrWorks = ["all", "remoteWork", "relocationRequired", "workFromHome"];
  searchContent: any;
  userIdStorage = localStorage.getItem('userId')
  candiSourceSearchRoute = null
  searchUserType: any
  candiSourceSelectNetRoute: any
  ScreenLoadBool: boolean = false
  subscription: Subscription;
  isAccordionOpen: boolean;
  messageData: any;
  messagemodelflag: Boolean = false;
  personalNetworks: any;
  publishedByUsers: any;
  businessCustomers: any;
  businessNetworks: any;
  //job classification
  availableForCheckboxes = [
    { label: 'All', selected: false, disable: false },
    { label: 'Corp To Corp', selected: false, disable: false },
    { label: 'W2 - Contract', selected: false, disable: false },
    { label: 'W2 - Full Time', selected: false, disable: false },
    { label: 'Part Time', selected: false, disable: false },
    { label: 'Freelance', selected: false, disable: false },
    { label: 'Internship', selected: false, disable: false },
    { label: 'Contract to Hire', selected: false, disable: false },
    { label: 'Other', selected: false, disable: false },
    // { label: 'Direct Hire', selected: false, disable: false },
  ];
  availablecheckbox = [
    { label: 'All', selected: false, disable: false },
    { label: 'Immediate', selected: false, disable: false },
    { label: '1 Week', selected: false, disable: false },
    { label: '2 Weeks', selected: false, disable: false },
    { label: 'Other', selected: false, disable: false }

  ];
  workModeCheckboxes: Array<{ label: string, selected: boolean, disable: boolean }> = [
    { label: 'All', selected: false, disable: false },
    { label: 'Onsite', selected: false, disable: false },
    { label: 'Remote', selected: false, disable: false },
    { label: 'Hybrid', selected: false, disable: false },
  ];
  candidate_status = [];
  statusCheckboxes: Array<{ label: string, selected: boolean, disable: boolean }> = [
    { label: 'All', selected: false, disable: false },
    { label: 'Draft', selected: false, disable: false },
    { label: 'Available', selected: false, disable: false },
    // { label: 'Shortlisted', selected: false, disable: false },
    // { label: 'Interview', selected: false, disable: false },
    // { label: 'Offered', selected: false, disable: false },
    // { label: 'Onboarded', selected: false, disable: false },
    // { label: 'On Contract', selected: false, disable: false },
    // { label: 'Featured', selected: false, disable: false },
    { label: 'Unavailable', selected: false, disable: false },


  ];
  WACheckboxes: Array<{ label: string, selected: boolean, disable: boolean }> = [];
  ischeckedJobSource: boolean = false
  ischeckedJobSourceAll: boolean = false
  ischeckedClientType: boolean = false
  ischeckedClientTypeAll: boolean = false
  ischeckedStatus: boolean = false
  ischeckedStatusAll: boolean = false
  ischeckedJobClassification: boolean = false
  ischeckedJobClassificationAll: boolean = false
  ischeckedWorkType: boolean = false
  ischeckedWorkTypeAll: boolean = false
  totalmsgcount: Subscription;
  totalmsgcounts: number = 0;
  uniqueColorClasses = [
    'fa fa-circle font-9 icon-prime-color',
    'fa fa-circle font-9 icon-red-color',
    'fa fa-circle font-9 icon-blue-color',
    'fa fa-circle font-9 icon-saffron-color',
    'fa fa-circle font-9 icon-green-color',
    'fa fa-circle font-9 icon-orange-color',
    'fa fa-circle font-9 icon-yellow-color'
  ];
  repetitions = 40;
  feaJ: boolean;
  profile: any
  networkflag: boolean = false;
  /** When a caller routes here with `?source=myCandidates` (or comma-separated
   *  list), these take precedence over the default userType-based source
   *  filters in `updateCandidateFilterData()`. One-shot: cleared after use. */
  sourceFilterFromRoute: string[] | null = null;
  deactivatedCandidates: Array<candidateModel>
  modalRef: BsModalRef
  sendProfileData: any = {}
  validTotalPoints: boolean
  totalCount
  listingCount = 0;
  freelanceCount = 0;
  creditsConsume: any = 0;
  candidatesData: Array<candidateModel> = [];
  valid: boolean = true;
  triggerapi = new BehaviorSubject('null');
  availablePoints;
  queryParamsValues: any
  //@ViewChild('listingCandidate', { static: false }) listingmodal: TemplateRef<any>;
  img: any;
  obj: any = {
    limit: 10,
    searchAfterKey: null,
    userId: localStorage.getItem('userId')
  }
  obj1: any = {
    limit: 10,
    searchAfterKey: null,
    userId: localStorage.getItem('userId')
  }
  yearApplied: boolean = false
  backdropConfig = {
    backdrop: true,
    ignoreBackdropClick: true,
    keyboard: false
  }
  selectedCandidateData: candidateModel;
  postDateApplied: boolean = false
  previousSearchAfterKey = null;
  statusFlag: boolean = false
  myCandidateFlag: boolean = false
  countryFlag: boolean = false
  totalExperienceFlag: boolean = false
  benchCandidatesFlag: boolean = false
  remoteWorkFlag: boolean = false
  postedInDaysFlag: boolean = false
  experienceToFlag: boolean = false
  experienceFromFlag: boolean = false
  cityFlag: boolean = false
  zipcodeFlag: boolean = false
  workFromHomeFlag: boolean = false
  stateFlag: boolean = false
  relocationRequiredFlag: boolean = false
  engagementTypeFlag: boolean = false
  workAuthorizationFlag: boolean = false
  featuredCandidatesFlag: boolean = false
  totalCandidatesCount: number = 0;
  datas: any = {};
  isMyCandidateShowedOnLoad: boolean = false;
  @Input() screenName: any;
  filterSubscriber: Subscription;
  candidateConnectionSubscription: Subscription;
  routingvalue: Subscription;
  isFilterOpen: boolean = false;
  panel: string;
  unsubscribe$: boolean = false;
  isActivityWidgetShown: boolean = false;
  pageYetToLoad: boolean = true;
  candidatePortfolioModule: any;
  candidateModule: jobModuleConfig;
  filterConfig: filterConfig;
  tempFilterChanges: any;
  filterChanges: any;
  candidateId: any;
  jobIdgetfromIntraction: string;
  tabName: string;
  filterPayLoad: CandidateFilterModel = {};
  FilterSubscription: Subscription;
  @ViewChild("widgetsticky") menuElement: ElementRef;
  isMyJobsShowedOnLoad: boolean = false;
  jobDataToBeSent: any;
  apiCompleted: boolean = false;

  showWorkAuthorization: boolean = false
  searchObserver = new Subject<string>();
  fromContent: "SUGGESTED_CANDIDATES" | "FEATURED_CANDIDATE" | "CANDIDATES_FROM_CONNECTION" | "BENCH_SALES_NETWORK" | "MANAGEMENT_TALENT_ACQUISITION_NETWORK" | "FREELANCE_RECRUITER_NETWORK";
  singleCandidateViewFromEyeIcon: boolean = false;
  networkType: string = ""
  CANDIDATE_STATUS: string = "";
  loadAPIcall: boolean = true;
  loadSkeleton = new BehaviorSubject<boolean>(false);
  loadCenterSkeleton = new BehaviorSubject<boolean>(false);
  selectedNetworkId: any;
  businessId: any;
  tempPersonalNetwork: any;
  workModeData: any;
  // Track the detail header "More" dropdown state to coordinate with candidate card dropdowns
  openDetailHeaderDropdown: boolean = false;
  dropdownCoordinatorSubscription: Subscription = null as any;


  constructor(private apiService: ApiService, private commonvalues: CommonValues, private modalService: BsModalService, private pageType: PageType,
    private pricePlanService: PricePlanService, private activatedRoute: ActivatedRoute, private formBuilder: UntypedFormBuilder, private candidateService: CandidateService,
    private searchData: SearchData, private jobService: JobService, private communicationService: CommunicationService,
    private gigsumoService: GigsumoService, private cdr: ChangeDetectorRef) {
      this.loadSkeleton.next(true);
      this.loadCenterSkeleton.next(true);

    this.BaseresponseFilter();
    this.filterSubscriber = this.jobService.getSliderToggle().subscribe(value => {
      this.panel = value.panel;
      this.entitySent.entity = value.panel;
      if (value.panel == 'candidates') {
        if (value.value == true) {
          this.openFilterSlider();
        } else {
          this.closeFilterSlider();
        }
      }
    })

    this.totalmsgcount =this.commonvalues.getMsgCount().subscribe(count => {
      this.totalmsgcounts = count;
    });

    this.routingvalue = this.activatedRoute.queryParams.subscribe((res) => {
      this.queryParamsValues = res;

      // Preselect source filter when caller routes with e.g. `?source=myCandidates`
      // (comma-separated list for multiple sources). Consumed below by
      // `updateCandidateFilterData()`, which runs after the form is built.
      if (res.source) {
        this.sourceFilterFromRoute = String(res.source)
          .split(',')
          .map((s: string) => s.trim())
          .filter((s: string) => !!s);
      }

      if (res.candidateId && res.tabName) {
        this.singleCandidateView = true;
        this.candidateId = res.candidateId;
        this.jobIdgetfromIntraction = res.jobId;
        this.tabName = res.tabName;
        if (res.From) {
          this.singleCandidateViewFromEyeIcon = true;
        }
        this.fromContent = res.From;
      }
      else if (res.createCandidate) {
        this.afterCandidateCreated = true;
        this.candidateId = res.createCandidate;
        this.CANDIDATE_STATUS = res.status;
        this.artificialAddNeeded = res.artificialAdd === 'true';
        this.createdCandidateData = {
          candidateId: res.createCandidate,
          status: res.status,
          fullCandidateData: res.candidateData ? JSON.parse(res.candidateData) : null
        };
      }
      else if (res.networkName) {
        this.networkflag = true;
        if (res.networkName === 'BENCH_SALES_NETWORK') {
          this.networkType = "benchNetworkCandidates";
        } else if (res.networkName === 'MANAGEMENT_TALENT_ACQUISITION_NETWORK') {
          this.networkType = "mtaNetworkCandidates";
        } else if (res.networkName === 'FREELANCE_RECRUITER_NETWORK') {
          this.networkType = "freeLancerNetworkCandidates";
        } else if (res.networkName === 'JOB_SEEKER_NETWORK') {
          this.networkType = "jobSeekerNetworkCandidates";
        } else if (res.networkName === 'OWNER') {
          this.networkType = "OWNER";
        } else if (res.networkName === 'PERSONAL_NETWORK') {
          this.networkType = res.networkName;
          this.selectedNetworkId = res.networkId;
        }
      }
    });

    this.candidateConnectionSubscription = this.commonvalues.getCandidateData().subscribe(candidateObject => {
      console.log("called " , candidateObject);

      this.updateConnectionStatus(candidateObject);
    });

    // Listen for dropdown state changes from candidates-page to close detail header dropdown
    this.dropdownCoordinatorSubscription = this.searchData.getDropdownState().subscribe(state => {
      if (state.open && (state.type === 'kebab' || state.type === 'status')) {
        this.openDetailHeaderDropdown = false;
        this.cdr.detectChanges();
      }
    });


  }

  async getBusinessDetails(){
    try {
      const response = await firstValueFrom(this.apiService.query(`business/findUserRoleInBusiness/${localStorage.getItem('userId')}`));
      return response;
    } catch (error) {
      return {
        code : "99999"
      }
    }
  }


  removeJobId(data) {
    this.jobIdgetfromIntraction = undefined;
  }

  // Base response for Filter
  BaseresponseFilter() {
    this.filterPayLoad = {
      "source": {
        "all": false,
        "myCandidates": false,
        "marketPlaceCandidates": false,
        "teamCandidates": false,
        "benchNetworkCandidates": false,
        "freeLancerNetworkCandidates": false,
        "mtaNetworkCandidates": false,
        "jobSeekerNetworkCandidates": false,
        "featured": false,
        "suggestedCandidates": false
      },
      "workMode" : [],
      "workAuthorization": [],
      "engagementType": [],
      "availableIn": [],
      "status": [],
      "searchAfterKey": null,
      "city": null,
      "state": null,
      "country": null,
      "zipCode": null,
      "submissionFilters": [],
      "postedFrom": null,
      "postedTo": null,
      "limit": 20,
      "userId": localStorage.getItem("userId"),
      "searchContent": "",
      "candidatesToFilter": this.candidateId
    }
  }

  async singlejobMethod() {
    await this.findByCandidateId(this.candidateId);
  }



  createCandidateFilterForm() {
    this.candidateFilterForm = this.formBuilder.group({
      source: this.formBuilder.array([
        this.formBuilder.group({
          all: false,
          benchNetworkCandidates: false,
          businessNetwork: false,
          featured: false,
          freeLancerNetworkCandidates: false,
          jobSeekerNetworkCandidates: false,
          marketPlaceCandidates: false,
          memberNetworksCandidates: false,
          mtaNetworkCandidates: false,
          myCandidates: false,
          suggestedCandidates: false,
          teamCandidates: false,
        })
      ]),
      workMode:[],
      availableIn: null,
      engagementType: null,
      status: null,
      submissionFilters: null,
      workAuthorization: null,
      resetFilter: null,
      searchAfterKey: null,
      country: null,
      userId: localStorage.getItem('userId'),
      postedDayRange: 'Any (Days)',
      experienceType: 'Any (Years)',
      state: null,
      city: null,
      zipCode: null,
      limit: 10,
      totalExperience: null,
      postedFrom: null,
      postedTo: null,
    });

    this.jobsoucefilterFrom();

  }

  async jobsoucefilterFrom() {
    if (this.networkflag) {
      const jobFilterData: any = await this.gigsumoService.getFilterPayload("CANDIDATE", this.userIdStorage);
      if (jobFilterData.code === GigsumoConstants.SUCESSCODE) {
        this.personalNetworks = jobFilterData.data.personalNetworks.map(r => {
          let data = GigsumoService.FILTER_ITEMS("CANDIDATE").find(x => x.key === this.networkType);
          if (data) {
            if (data.value === r.networkName) {
              return r.networkId;
            }
            return;
          }
        }).filter((networkId: string) => networkId != undefined);

        if(this.selectedNetworkId!=null){
          this.personalNetworks = [this.selectedNetworkId];
        }

        this.tempPersonalNetwork = this.personalNetworks;

      }
      this.updateCandidateFilterData();
      this.handlePrerequisites();


    } else {
      this.jobSourcesFormarray.push(this.jobSourcefields())
      this.updateCandidateFilterData();
      this.handlePrerequisites();
    }
  }

  async handlePrerequisites() {
    const business : any = await this.getBusinessDetails();

    if(business.code === GigsumoConstants.SUCESSCODE){
        this.businessId = business.data.businessData.businessId;
    }

    if (!this.singleCandidateView) {
      this.RoleBasedFilter();
    }
    else {
      this.singlejobMethod();
    }
  }

  get jobSourcesFormarray() {
    return this.candidateFilterForm.get('source') as UntypedFormArray;
  }

  jobSourcefields(): UntypedFormGroup {
    return this.formBuilder.group({
      all: false,
      myCandidates: false,
      marketPlaceCandidates: false,
      teamCandidates: false,
      benchNetworkCandidates: false,
      freeLancerNetworkCandidates: false,
      mtaNetworkCandidates: false,
      jobSeekerNetworkCandidates: false,
      businessNetwork: false,
      memberNetworksCandidates: false,
      // featured: false,
      // suggestedCandidates: false,

    });
  }



  RoleBasedFilter() {
    this.diffcolourLabel();
    this.prepareFilterPayload();
    this.jobDataToBeSent = this.jobData
    this.filterapicall();
  }

  prepareFilterPayload() {
    this.filterPayLoad = { ...this.filterPayLoad, searchAfterKey: null };
    this.response.next([]);
    this.previousSearchAfterKey = null;
    this.obj.searchAfterKey = null;
    this.stopscrollFlag = false;
  }

  diffcolourLabel() {
    let colurclass = [];
    for (let i = 0; i < this.repetitions; i++) {
      colurclass = colurclass.concat(this.uniqueColorClasses);
    }
  }

  updateJobSourceAndFilter(candidateSourceType) {
    this.filterPayLoad.source[candidateSourceType] = true;
    this.candidateSource.push(candidateSourceType);
    this.candidateSource = [...new Set(this.candidateSource)];
  }

  clearFilterselectedcount() {
    this.communicationService.triggerMethod('candidates');
  }


  ngOnInit(): void {
    this.createCandidateFilterForm();
    // this.updateCandidateFilterData(); //these got moved into the above method this.createCandidateFilterForm() to handle async/await scenario

    // if (!this.singleCandidateView) {
    //   this.RoleBasedFilter();
    // }
    // else {
    //   this.singlejobMethod();
    // }


    //update filter passing function 
    this.updateFilterPassing();
    this.updateCandidateModule();
    this.updateCandidatePortfolioModule();


    // search filter
    this.searchObserver.pipe(
      auditTime(500),
      distinctUntilChanged(),
      debounceTime(1000),
    ).subscribe((res: any) => {
      if (res != "") {
        this.loadCenterSkeleton.next(true);
        this.filterPayLoad.searchContent = res;
        this.filterPayLoad.searchAfterKey = null;
        this.filterPayLoad.candidatesToFilter = null;
        this.singleCandidateView = false;
        this.afterCandidateCreated = false;
        this.filterapicall(res);
      }
      else if (res === null) {
        this.loadCenterSkeleton.next(true);
        this.filterPayLoad.searchContent = "";
        this.filterPayLoad.searchAfterKey = null;
        this.filterPayLoad.candidatesToFilter = null;
        this.singleCandidateView = false;
        this.afterCandidateCreated = false;
        this.filterapicall();
      }
    });


    this.scrollSubject.pipe(
      debounceTime(100)
    ).subscribe(data => {
      this.filterPayLoad.searchAfterKey = this.previousSearchAfterKey;
      this.filterapicall();
    });

  }

  async updateBenefits() {
    await this.pricePlanService.UPDATE_USERDETAILS("ACTIVE_INTERACTIONS");
  }

  ngOnDestroy(): void {
    if (this.filterSubscriber) {
      this.filterSubscriber.unsubscribe();
    }
    // Was leaked: an in-flight candidates/filter call outlived the page and
    // ran handleResponse against a destroyed component.
    this.FilterSubscription?.unsubscribe();
    if (this.totalmsgcount != undefined) {
      this.totalmsgcount.unsubscribe();
    }
    if (this.routingvalue) {
      this.routingvalue.unsubscribe();
    }
    if (this.candidateConnectionSubscription) {
      this.candidateConnectionSubscription.unsubscribe();
    }
    if (this.dropdownCoordinatorSubscription) {
      this.dropdownCoordinatorSubscription.unsubscribe();
    }
    // Clear artificial candidate insertion timeout
    if (this.artificialInsertTimeout) {
      clearTimeout(this.artificialInsertTimeout);
    }
  }


  showApplicantFilter: boolean = true;
  filterReset(data) {
    if (data.pageName == 'cInvited' || data.pageName == 'jobsApplied') {
      this.showApplicantFilter = true;
    } else {
      this.showApplicantFilter = false;
    }
  }

  getOwnerNetwork(userType: USER_TYPE): Array<string> {

    const arr = ['benchNetworkCandidates', 'freeLancerNetworkCandidates',
      "mtaNetworkCandidates", "jobSeekerNetworkCandidates", "myCandidates"];

    if (this.isRecruiter(userType)) {
      arr.splice(arr.length - 1, 1);
    }

    return arr;
  }


  updateCandidateFilterData() {

    const userType = localStorage.getItem('userType') as USER_TYPE;

    // Route-provided source filter (e.g. "My bench →" from Bench Sales Dashboard
    // sends `?source=myCandidates`) — takes precedence over userType defaults.
    if (this.sourceFilterFromRoute && this.sourceFilterFromRoute.length) {
      this.clearCandidateSourceControl();
      this.patchCandidateSourceasArr(this.sourceFilterFromRoute, true);
      this.setDefaultFilter(this.sourceFilterFromRoute, true);
      this.sourceFilterFromRoute = null;  // one-shot — honor subsequent user edits
      return;
    }

    if (this.networkflag ) {

      if(this.networkType === "PERSONAL_NETWORK"){
        this.setDefaultFilter("");
        return;
      }

      const reset = this.candidateFilterForm.get("resetFilter").value;

      if(!reset){
        if(this.tempPersonalNetwork != null){
          this.personalNetworks = this.tempPersonalNetwork
        }
        this.clearCandidateSourceControl();
        this.patchCandidateSourceTrue(this.networkType);
        this.setDefaultFilter("");
        return;
      }

    }


    //  if user routing for single job clear the source 
    if (this.singleCandidateView) {

      if (this.singleCandidateViewFromEyeIcon) {
        let filterName: Array<string> = [];
        this.setDefaultFilter(filterName, true);
        this.searchData.setHighlighter('newCandidates');
        return;
      }

    }
    // route based on the userTypes
    else{

      if (this.isMTAorFREEandREC(userType)) {
  
        // after creating candidate
        if (this.afterCandidateCreated) {
          this.afterCandidateCreated = userType === GigsumoConstants.RECRUITER ? false : true;
        }
  
   
        if (this.isMTAorFREE(userType)) {
          let arr = this.afterCandidateCreated ? ["myCandidates"] : ["myCandidates", "marketPlaceCandidates"];
          this.patchCandidateSourceasArr(arr, true);
          this.setDefaultFilter(arr, true);
        }
        else {
          this.setDefaultFilter("marketPlaceCandidates");
        } 
  
  
      }
      else if (this.isBenchorJob(userType)) {
        let arr = this.afterCandidateCreated ? ["myCandidates"] : ["myCandidates", "marketPlaceCandidates"];
        this.patchCandidateSourceasArr(arr, true);
        this.setDefaultFilter(arr, true);
      }

    }

  }
  updateFilterIfuserFromRouting(): string[] {
    this.clearCandidateSourceControl();
    switch (this.fromContent) {
      case "SUGGESTED_CANDIDATES":
        this.patchCandidateSourceTrue('suggestedCandidates');
        return ["suggestedCandidates"];
      case "FEATURED_CANDIDATE":
        this.patchCandidateSourceTrue('featured');
        return ["featured"];
      case "CANDIDATES_FROM_CONNECTION":
        this.patchCandidateSourceTrue('benchNetworkCandidates');
        this.patchCandidateSourceTrue('freeLancerNetworkCandidates');
        this.patchCandidateSourceTrue('mtaNetworkCandidates');
        this.patchCandidateSourceTrue('jobSeekerNetworkCandidates');
        return ["benchNetworkCandidates", "freeLancerNetworkCandidates", "mtaNetworkCandidates", "jobSeekerNetworkCandidates"];
      case "BENCH_SALES_NETWORK":
        this.patchCandidateSourceTrue('benchNetworkCandidates');
        return ["benchNetworkCandidates"]
      case "FREELANCE_RECRUITER_NETWORK":
        this.patchCandidateSourceTrue('freeLancerNetworkCandidates');
        return ["freeLancerNetworkCandidates"]
      case "MANAGEMENT_TALENT_ACQUISITION_NETWORK":
        this.patchCandidateSourceTrue('mtaNetworkCandidates');
        return ["mtaNetworkCandidates"];
      default:
        break;
    }
  }

  patchCandidateSourceTrue(key: string) {
    this.getSource().at(0).get(key).patchValue(true);
  }


  patchCandidateSourceasArr(arr: Array<string>, value: boolean) {
    for (const key of arr) {
      this.getSource().at(0).get(key).patchValue(value);
    }
  }

  patchCandidateSourceFalse(key: string) {
    this.getSource().at(0).get(key).patchValue(false);
  }

  clearCandidateSourceControl() {
    Object.keys((this.jobSourcesFormarray.at(0) as FormGroup).controls).forEach(key=>{
      ((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get(key).patchValue(false);
    });
  }

  setDefaultFilter(value: string | Array<string>, fromRoute: boolean = false) {
    if(value){

      const userType = localStorage.getItem('userType') as USER_TYPE;

      const isOwner: boolean = ((fromRoute ? value.includes('myCandidates') : value === 'myCandidates') ||
        (!fromRoute && value === 'myCandidates' && !this.isRecruiter(userType)));

      if (fromRoute) {
        this.candidateSource = value as Array<string>;
      }
      else if (!fromRoute) {
        this.getSource().at(0).get(value).patchValue(true);
        this.candidateSource.push(value);
      }

      if (this.statusCheckboxes && isOwner) {
        this.statusCheckboxes[(this.CANDIDATE_STATUS != "DRAFTED" ? 2 : 1)].selected = true;
        this.candidateSource.push(this.CANDIDATE_STATUS != 'DRAFTED' ? 'Available' : "Draft");
      }

      this.tempFilterChanges = {};
      this.tempFilterChanges = {
        formData: this.candidateFilterForm.getRawValue(),
        checkedItems: this.candidateSource,
        statusCheckedItems: this.statusCheckboxes,
        availiabilityCheckedItems: this.availablecheckbox,
        engageMentCheckedItems: this.availableForCheckboxes,
        submissionItems: this.candidate_status,
        workMode: this.workModeCheckboxes,
        personalNetworks : this.personalNetworks,
      };
      this.filterPayLoad.source = this.getSource().at(0).value;
      this.filterPayLoad.status = isOwner ? this.CANDIDATE_STATUS != 'DRAFTED' ? ['Available'] : ["Draft"] : [];
      this.filterPayLoad.searchAfterKey = null;
      this.filterPayLoad.personalNetworks = this.personalNetworks;
    }
    else{
      this.statusCheckboxes[2].selected = true;
      this.candidateSource.push('Available');

      this.tempFilterChanges = {};
      this.tempFilterChanges = {
        formData: this.candidateFilterForm.getRawValue(),
        checkedItems: this.candidateSource,
        statusCheckedItems: this.statusCheckboxes,
        availiabilityCheckedItems: this.availablecheckbox,
        engageMentCheckedItems: this.availableForCheckboxes,
        submissionItems: this.candidate_status,
        personalNetworks : this.personalNetworks,
        workMode: this.workModeCheckboxes,
      };
      this.filterPayLoad.source = this.getSource().at(0).value;
      this.filterPayLoad.status =   ['Available'] ;
      this.filterPayLoad.searchAfterKey = null;
      this.filterPayLoad.personalNetworks = this.personalNetworks;

    }

  }

  getSource(): UntypedFormArray {
    return this.candidateFilterForm.get('source') as UntypedFormArray;
  }

  isBenchorJob(userType: USER_TYPE): boolean {
    return (userType === GigsumoConstants.BENCH_RECRUITER
      || userType === GigsumoConstants.JOB_SEEKER);
  }

  isMTAorFREEandREC(userType: USER_TYPE): boolean {
    return (userType === GigsumoConstants.MANAGEMENT_TALENT_ACQUISITION
      || userType === GigsumoConstants.FREELANCE_RECRUITER || userType === GigsumoConstants.RECRUITER);
  }

  isMTAorFREE(userType: USER_TYPE): boolean {
    return (userType === GigsumoConstants.MANAGEMENT_TALENT_ACQUISITION || userType === GigsumoConstants.FREELANCE_RECRUITER);
  }

  isRecruiter(userType: USER_TYPE): boolean {
    return (userType === GigsumoConstants.RECRUITER);
  }
  selectedCandidateData_View: any;
  findByCandidateId(candidateId: any) {
    this.candidateDetailsTabName = this.tabName;
    // this.filterPayLoad.source.myCandidates = true;
    // this.filterPayLoad.candidatesToFilter = this.candidateId;
    this.filterapicall();
  }






  JobAcvityDatas: any = {
    call: false
  };
  updatetocandidateActivity(data) {
    data.refereshDatas = new Date();
    data.call = true;
    if(data.checked != null){
      data.call = data.checked;
      data.data = [];
    }
    this.JobAcvityDatas = data;
    if (!data.isSelected) {
      this.JobAcvityDatas = { ...this.JobAcvityDatas };
    }

  }



  // get child date to display widgets
  getchildData(data) {
    if (data != null) {
      this.dataPasstoSkillwidgets = JSON.parse(data);

    } else {
      this.dataPasstoSkillwidgets = [];
    }
  }

  //  user remove after uncheck from widgets
  removeUserfromTag(data) {
    this.removeTagvalues = data;
    this.response.forEach(element => {
      if (element.candidateId == data.candidateId) {
        element.isSelected = false;
      }
    });

    this.dataPasstoSkillwidgets.forEach(element => {
      if (element.candidateId == data.candidateId) {
        element.isSelected = false;
      }
    });
  }


  scrollSubject = new Subject();
  onScrollDown() {
    if (!this.loadCenterSkeleton.getValue() && !this.stopscrollFlag && this.filterPayLoad.searchAfterKey != this.previousSearchAfterKey) {
      this.scrollSubject.next("");
    }
  }



  widgetstick: boolean = true
  suggestionStick: boolean = false
  @HostListener("window:scroll")
  handleScroll() {
    const windowScroll = window.pageYOffset;
    if (windowScroll >= 35) {
      this.suggestionStick = true;
    } else {
      this.suggestionStick = false;
    }
  }

  searchfilter(val: string) {
    this.searchObserver.next(val === "" ? null : val);
    this.stopscrollFlag = false;
  }

  API_NAME: string = 'candidates/filter';
  SUCCESS_CODE: string = GigsumoConstants.SUCESSCODE;
  filterapicall(searchContent: string = null) {
    
    this.loadSkeleton.next(true);
    this.loadAPIcall = true;
    this.filterPayLoad.businessId = this.businessId;
    this.apiCompleted = false
    this.InvitetoApplyFilter();
    this.commonvalues.changeData(true);

    if (this.candidateSource && this.userType==GigsumoConstants.JOB_SEEKER) {
      this.jobSeekerListName = (this.filterPayLoad.source &&
        this.filterPayLoad.source['myCandidates'] &&
        !this.checkKey(this.filterPayLoad.source).some(c => c === true)
      ) ?
        "Profile" : "Candidate";
    }

    // To check duplicate in candidate view ...

    // this.filterPayLoad.source.myCandidates=true;
    // this.filterPayLoad.source.marketPlaceCandidates=false;
    if (this.singleCandidateView || this.afterCandidateCreated) {
      this.filterPayLoad.candidatesToFilter = this.candidateId;
    }

    if (this.filterPayLoad.searchAfterKey === null) {
      this.response.next([]);
      const eleme =  document.getElementById('candidate-body');
      if (eleme) {
        eleme.scrollTo({ top: 0, behavior: "smooth" });
      }
    }

    // Latest call wins. Every entry point into this method (All Filters
    // Apply, the header Reset, a source chip, search, scroll) used to
    // overwrite FilterSubscription while the previous request was still in
    // flight, so a burst of clicks left several candidates/filter calls
    // racing and handleResponse ran for whichever settled last — the list
    // could end up holding a superseded page, or the pagination cursor of a
    // filter the user had already clicked past. Drop the stale request first.
    this.FilterSubscription?.unsubscribe();
    this.FilterSubscription = this.apiService.create(this.API_NAME, this.filterPayLoad)
      .subscribe(
        res => this.handleResponse(res, searchContent),
        err => this.handleError(err)
      );
  }

  // API success response
  handleResponse(res, searchContent: string) {
    this.loadAPIcall = false;
    this.commonvalues.changeData(false);
    if (res.code === this.SUCCESS_CODE) {

      const candidateData = res.data.candidateList;
      const currSearchAfterKey = res.data.searchAfterKey;

      if(candidateData && (candidateData.length === 0 || JSON.stringify(this.previousSearchAfterKey) === JSON.stringify(currSearchAfterKey))){
        this.stopscrollFlag = true;
      }
      this.previousSearchAfterKey = currSearchAfterKey;

      localStorage.setItem('candidateForm', JSON.stringify(this.filterPayLoad));

      this.apiCompleted = true
      this.CanidateListdata(res.data, searchContent);
    }
  }

  // API error responsec
  handleError(err) {
    this.loadAPIcall = false;
    this.commonvalues.changeData(false);

    // this.util.stopLoader();

  }


  CanidateListdata(data, searchContent: string) {

    this.loadSkeleton.next(false);
    this.loadCenterSkeleton.next(false);
    this.candidateFilterForm.get("resetFilter").patchValue(false);

    let content = this.filterPayLoad.searchContent;

    if ((content != null && searchContent != null && (content && content.trim()) === (searchContent && searchContent.trim()) && searchContent.length > 0)) {
      this.stopscrollFlag = false;
      this.response.next([]);

    }


    if (data.candidateList.length > 0) {
      const currentData = this.response.getValue();
      const existingIds = new Set(currentData.map(candidate => candidate.candidateId));
      const filteredNewCandidates = data.candidateList.filter(candidate => !existingIds.has(candidate.candidateId));

      let combinedResponse = [...currentData, ...filteredNewCandidates];

      // Handle artificial candidate insertion for ASYNC mode
      if (this.artificialAddNeeded && this.createdCandidateData) {
        const candidateExists = data.candidateList.some(candidate => candidate.candidateId === this.createdCandidateData.candidateId);
        if (candidateExists) {
          // Candidate found in response, ensure it's at the first position and selected
          const existingCandidateIndex = combinedResponse.findIndex(candidate => candidate.candidateId === this.createdCandidateData.candidateId);
          if (existingCandidateIndex > 0) {
            // Move the candidate to first position
            const [candidateToMove] = combinedResponse.splice(existingCandidateIndex, 1);
            combinedResponse.unshift(candidateToMove);
          }
          this.artificialAddNeeded = false;
        } else if (this.createdCandidateData.status !== 'DRAFT') {
          // Candidate not found and not a draft, add artificially immediately
          combinedResponse = this.artificiallyInsertCandidateInstantly(combinedResponse);
          this.artificialAddNeeded = false;
        }
      }

      this.response.next(combinedResponse);

      if (this.filterPayLoad.searchAfterKey === null && combinedResponse.length > 0) {
        // Always select the first candidate, which will be the newly created candidate if artificially inserted
        this.selectedCandidateData = combinedResponse[0];
        // Preserve a route-provided tab (e.g. ?tabName=jobsApplied from the
        // bench dashboard Spotlight "View all" link). Otherwise default to profileSummary.
        const keepRouteTab = this.singleCandidateView && !!this.tabName && this.tabName !== 'profileSummary';
        if (!keepRouteTab) this.candidateDetailsTabName = "profileSummary";

        // If this is an artificially added candidate, ensure it's properly selected
        if (this.artificialAddNeeded && combinedResponse[0].isArtificiallyAdded) {
          this.selectedCandidateData = combinedResponse[0];
        }

        if (this.selectedCandidateData && !this.selectedCandidateData.isViewed && this.selectedCandidateData.createdBy != this.userIdStorage) {
          console.log("Selected candidate data is ", this.selectedCandidateData);
          this.candidateService.updateCandidateViewed(this.selectedCandidateData).subscribe(res => {
            if (res.code === GigsumoConstants.SUCESSCODE) {
              this.selectedCandidateData.isViewed = true;
            }
          });
        }
      }
    } else {
      // Handle case where API returns no candidates but we need to insert artificially
      let combinedResponse = [...this.response.getValue()];
      
      if (this.artificialAddNeeded && this.createdCandidateData && this.createdCandidateData.status !== 'DRAFT') {
        combinedResponse = this.artificiallyInsertCandidateInstantly(combinedResponse);
        this.artificialAddNeeded = false;
        
        // Update the response and set selection
        this.response.next(combinedResponse);
        if (combinedResponse.length > 0) {
          this.selectedCandidateData = combinedResponse[0];
          // Preserve route-provided tab — see earlier comment for full rationale.
          const keepRouteTab = this.singleCandidateView && !!this.tabName && this.tabName !== 'profileSummary';
          if (!keepRouteTab) this.candidateDetailsTabName = "profileSummary";
        }
        return; // Exit early since we handled the response
      }
    }

    if (this.response.getValue().length == 0) {
      this.totalCandidatesCount = 0;
      this.JobAcvityDatas = null;
      this.selectedCandidateData = null;
      this.candidateFoundStatus = "Couldn't find any Candidates for the applied filters."
    }
    if (data.workAuthorization) {
      data.workAuthorization.forEach((res) => {
        this.WACheckboxes.forEach(item => {
          if (item.label === res) {
            this.showWorkAuthorization = true;
            item.selected = true;
            this.candidateSource.push(res);
          }
        });
      });
    }

    if (data.totalCandidatesCount !== undefined || data.totalCandidatesCount === 0) {
      this.totalCandidatesCount = data.totalCandidatesCount;
    }

  }


  candidateDetailsTabName: string = "profileSummary";

  updateCandidateModule() {
    let module = new jobModuleConfig(this.updateCandidateDetails);
    module.tabName = "profileSummary";
    module.source = this;
    this.candidateModule = module;
  }


  updateCandidatePortfolioModule() {
    let module = new jobModuleConfig(this.updateCandidatePortfolioDetails);
    module.tabName = "profileSummary";
    module.source = this;
    this.candidatePortfolioModule = module;
  }


  updateFilterPassing() {
    let revokeBtn: filterConfig = new filterConfig(this.candidateFilterData);
    revokeBtn.source = this;
    this.filterConfig = revokeBtn;
  }

  // filter interaction between horizontal and vertical happening here 
  candidateFilterData(data: any) {
    this.filterPayLoad.candidatesToFilter = null;
    this.singleCandidateView = false;
    this.candidateId = null;


    if (data != null && data.from === "HORIZANTAL") {
      // console.log("FILTERTRIGERED ", data);
      this.tempFilterChanges = data;
      this.availablecheckbox = data.availiabilityCheckedItems;
      this.statusCheckboxes = data.statusCheckedItems;
      this.availableForCheckboxes = data.engageMentCheckedItems;
      this.candidateSource = [...new Set(data.checkedItems)];
      this.businessNetworks = data.businessNetworks;
      this.personalNetworks = data.personalNetworks;
      this.businessCustomers = data.businessCustomers;
      this.publishedByUsers = data.publishedByUsers;
      this.workModeData = data.workMode;
      this.stopscrollFlag = false;
      this.loadCenterSkeleton.next(true);
      this.updateFilterData();
    }
    else if (data != null && data.from === "VERTICAL") {
      this.tempFilterChanges = data;
      this.availablecheckbox = data.availiabilityCheckedItems;
      this.statusCheckboxes = data.statusCheckedItems;
      this.availableForCheckboxes = data.engageMentCheckedItems;
      this.candidate_status = data.submissionItems;
      this.candidateSource = [...new Set(data.checkedItems)];
      this.personalNetworks = data.personalNetworks;
      this.businessNetworks = data.businessNetworks;
      this.businessCustomers = data.businessCustomers;
      this.publishedByUsers = data.publishedByUsers;
      this.workModeData = data.workMode;

    }


  }


  updateFilterData() {
    const { formData: { source, ...rest } } = this.tempFilterChanges;
    this.filterPayLoad = {
      searchContent: this.filterPayLoad.searchContent,
      ...rest,
      source: source[0],

    }

    if (this.candidateSource) {
      this.jobSeekerListName = (this.filterPayLoad.source &&
        this.filterPayLoad.source['myCandidates'] &&
        !this.checkKey(this.filterPayLoad.source).some(c => c === true)
      ) ?
        "Profile" : "Candidate";
    }

    if(this.tempFilterChanges.workAuthorization){
      this.filterPayLoad.workAuthorization = this.tempFilterChanges.workAuthorization.filter(element => element.selected).map(element => element.label);;
    }
    this.filterPayLoad.searchAfterKey = null;
    this.previousSearchAfterKey = null;
    this.stopscrollFlag = false;
    this.filterPayLoad.limit = 20;
    this.filterPayLoad.workMode = Array.isArray(this.workModeData)
    ? this.workModeData.filter(element => element.selected).map(element => element.label)
    : [];
    this.filterPayLoad.userId = localStorage.getItem('userId');
    this.filterPayLoad.status = this.statusCheckboxes.filter(element => element.selected).map(element => element.label);
    this.filterPayLoad.availableIn = this.availablecheckbox.filter(element => element.selected).map(element => element.label);
    this.filterPayLoad.submissionFilters = this.candidate_status.filter(element => element.selected).map(element => element.value);
    this.filterPayLoad.engagementType = this.availableForCheckboxes.filter(element => element.selected).map(element => element.label);
    this.filterPayLoad.personalNetworks = this.personalNetworks;
    this.filterPayLoad.businessNetworks = this.businessNetworks;
    this.filterPayLoad.publishedBy = this.publishedByUsers;
    this.filterPayLoad.customers = this.businessCustomers;
    this.filterapicall();
  }


  checkKey(dt: any) {
    return Object.keys(dt).reduce((acc, dd) => {
      if (dd != "myCandidates") {
        acc.push(dt[dd]);
      }
      return acc
    }, []);
  }




  // when user close or apply the filter from vertical filter this will get triggered 
  onFilterToggle(value: any) {
    // this.response.next([]);
    this.filterApplied = false;
    this.stopscrollFlag = false;
    if (this.panel == 'candidates') {
      if (value === 'reset') {
        this.jobService.setSliderToggle(false, this.panel, value,true);
        this.resetFilternew();
        // Trigger change detection to update filter count badge
        this.cdr.detectChanges();
        return;
      }
      this.afterFilterPrepareForm();
      // Trigger change detection to update filter count badge
      this.cdr.detectChanges();
    } else if (this.panel == 'job invites') {
      this.jobService.setSliderToggle(false, this.panel, value,false);
    } else if (this.panel == 'jobs applied') {
      this.jobService.setSliderToggle(false, this.panel, value,false);
    }
  }


  // Sidebar filter API call
  afterFilterPrepareForm() {
    this.ScreenLoadBool = true;
    const { formData: { source, ...rest } } = this.tempFilterChanges;
    this.filterPayLoad = {
      searchContent: this.filterPayLoad.searchContent,
      ...rest,
      source: source[0],
    }
    // this.filterPayLoad.workAuthorization = [];
    if(this.tempFilterChanges.workAuthorization){
      this.filterPayLoad.workAuthorization = this.tempFilterChanges.workAuthorization.filter(element => element.selected).map(element => element.label);;
    }
    this.filterPayLoad.searchAfterKey = null;
    this.previousSearchAfterKey = null;
    this.stopscrollFlag = false;
    this.loadCenterSkeleton.next(true);
    this.filterPayLoad.limit = 20;
    this.filterPayLoad.userId = localStorage.getItem('userId');
    this.filterPayLoad.status = this.statusCheckboxes.filter(element => element.selected).map(element => element.label);
    this.filterPayLoad.availableIn = this.availablecheckbox.filter(element => element.selected).map(element => element.label);
    if (this.candidate_status != undefined) {
      this.filterPayLoad.submissionFilters = this.candidate_status.filter(element => element.selected).map(element => element.itemId);
    }
    this.filterPayLoad.engagementType = this.availableForCheckboxes.filter(element => element.selected).map(element => element.label);
    this.filterPayLoad.personalNetworks = this.personalNetworks;
    this.filterPayLoad.workMode = Array.isArray(this.workModeData)
    ? this.workModeData.filter(element => element.selected).map(element => element.label)
    : [];
    this.filterPayLoad.businessNetworks = this.businessNetworks;
    this.filterPayLoad.customers = this.businessCustomers;
    this.filterPayLoad.publishedBy = this.publishedByUsers;
    this.filterapicall();
  }

  initializePayload(data) {
    this.filterPayLoad = { ...data, searchAfterKey: null };
    this.previousSearchAfterKey = null;
    this.obj.searchAfterKey = null;
    this.stopscrollFlag = false;
  }

  updateCheckboxes(data, key, checkboxes) {
    data[key].forEach(res => {
      checkboxes.forEach(item => {
        if (item.label === res) {
          item.selected = true;
          this.candidateSource.push(res);
        }
      });
    });
  }



  // updateSourceWorkType(data, type) {
  //   if (type == 'source') {
  //     for (let key in data.source) {
  //       if (data.source[key] === true) {
  //         this.filterPayLoad.source[0].key = true;
  //         this.candidateSource.push(key);
  //       }
  //     }
  //   } else if (type == 'workType') {
  //     for (let key in data.workType) {
  //       if (data.source[key] === true) {
  //         this.filterPayLoad.workType[0].key = true;
  //         this.candidateSource.push(key);
  //       }
  //     }
  //   }
  // }


  resetFilternew() {
    this.clearCreateJobRouteValue();
    this.loadCenterSkeleton.next(true);
    this.value = 0;
    this.highValue = 0;
    this.value1 = 0;
    this.highValue1 = 0;
    this.previousSearchAfterKey = null;
    this.filterPayLoad.searchAfterKey = null;
    this.candidateSource = [];
    this.candidateFilterForm.reset();
    this.candidateFilterForm.get("resetFilter").patchValue(true);
    this.candidateFilterForm.get('experienceType').patchValue('Any (Years)');
    this.candidateFilterForm.get('postedDayRange').patchValue('Any (Days)');
    this.statusCheckboxes = this.resetStatusCheckBox();
    this.workModeCheckboxes= this.resetworkModeCheckBox();
    this.availableForCheckboxes = this.resetClientTypeCheckBox();
    this.availablecheckbox = this.resetEngagementTypeCheckBox();
    this.candidate_status = this.resetSubmissionFilter();
    this.personalNetworks = [];
    this.businessCustomers = [];
    this.publishedByUsers = [];
    this.businessNetworks = [];
    this.BaseresponseFilter();
    this.updateCandidateFilterData();
    this.filterapicall();
    this.clearFilterselectedcount();
    // Trigger change detection to update filter count badge
    this.cdr.detectChanges();
  }

  clearCreateJobRouteValue(){
    this.singleCandidateView = false;
    this.afterCandidateCreated = false;
    this.networkflag = false;
    this.singleCandidateViewFromEyeIcon = false;
    this.fromContent = null;
    this.candidateId = null;
    this.CANDIDATE_STATUS = "Available";
    // Clear artificial add logic
    clearTimeout(this.artificialInsertTimeout);
    this.artificialAddNeeded = false;
    this.createdCandidateData = null;
    this.artificialInsertTimeout = null;
  }

  artificiallyInsertCandidateInstantly(combinedResponse: any[]) {
    if (!this.createdCandidateData || this.createdCandidateData.status === 'DRAFT' || !this.createdCandidateData.fullCandidateData) {
      return combinedResponse;
    }

    // Check if candidate doesn't already exist (avoid duplicates)
    const candidateExists = combinedResponse.some(candidate => candidate.candidateId === this.createdCandidateData.candidateId);
    
    if (!candidateExists) {
      // Get current user's profile data from localStorage
      const userId = localStorage.getItem('userId');
      const userName = localStorage.getItem('userName');
      const profilePhoto = localStorage.getItem('profilePhoto');
      const userType = localStorage.getItem('userType');
      const currentOrganization = localStorage.getItem('currentOrganization');
      const busLogo = localStorage.getItem('busLogo');
      
      // Use the actual candidate data from the API response and add missing user profile data
      const artificialCandidate = {
        ...this.createdCandidateData.fullCandidateData,
        isArtificiallyAdded: true,
        user: {
          userId: userId,
          fullname: userName,
          photo: profilePhoto && profilePhoto !== 'null' ? profilePhoto : undefined,
          userType: userType,
          workExperience: [{
            organisationName: currentOrganization,
            businessLogo: busLogo && busLogo !== 'null' ? busLogo : undefined,
            currentOrganization: true
          }],
          ...this.createdCandidateData.fullCandidateData.user // Keep any existing user data from API
        }
      };
      
      // Insert actual candidate data at the beginning (index 0)
      combinedResponse.unshift(artificialCandidate);
    }

    return combinedResponse;
  }

  artificiallyInsertCandidate() {
    if (!this.createdCandidateData || this.createdCandidateData.status === 'DRAFT' || !this.createdCandidateData.fullCandidateData) {
      return;
    }

    const currentData = this.response.getValue();
    // Check if candidate doesn't already exist (avoid duplicates)
    const candidateExists = currentData.some(candidate => candidate.candidateId === this.createdCandidateData.candidateId);
    
    if (!candidateExists) {
      // Get current user's profile data from localStorage
      const userId = localStorage.getItem('userId');
      const userName = localStorage.getItem('userName');
      const profilePhoto = localStorage.getItem('profilePhoto');
      const userType = localStorage.getItem('userType');
      const currentOrganization = localStorage.getItem('currentOrganization');
      const busLogo = localStorage.getItem('busLogo');
      
      // Use the actual candidate data from the API response and add missing user profile data
      const artificialCandidate = {
        ...this.createdCandidateData.fullCandidateData,
        isArtificiallyAdded: true,
        user: {
          userId: userId,
          fullname: userName,
          photo: profilePhoto && profilePhoto !== 'null' ? profilePhoto : undefined,
          userType: userType,
          workExperience: [{
            organisationName: currentOrganization,
            businessLogo: busLogo && busLogo !== 'null' ? busLogo : undefined,
            currentOrganization: true
          }],
          ...this.createdCandidateData.fullCandidateData.user // Keep any existing user data from API
        }
      };
      
      // Insert actual candidate data at the beginning (index 0)
      const updatedData = [artificialCandidate, ...currentData];
      this.response.next(updatedData);
    }

    // Clean up
    this.artificialAddNeeded = false;
    this.artificialInsertTimeout = null;
  }


  resetStatusCheckBox(): Array<any> {
    return this.statusCheckboxes.map((val: any) => {
      val.selected = false
      return val;
    });
  }
  resetworkModeCheckBox(): Array<any> {
    return this.workModeCheckboxes.map((val: any) => {
      val.selected = false
      return val;
    });
  }
  resetClientTypeCheckBox(): Array<any> {
    return this.availableForCheckboxes.map((val: any) => {
      val.selected = false
      return val;
    });
  }

  resetEngagementTypeCheckBox(): Array<any> {
    return this.availablecheckbox.map((val: any) => {
      val.selected = false
      return val;
    });
  }

  resetSubmissionFilter(): Array<any> {
    return this.candidate_status.map((val: any) => {
      val.selected = false
      return val;
    });
  }


  removeEntitynew(value, index) {
    this.candidateSource.splice(index, 1);

    Object.keys(this.filterPayLoad.source).forEach((key: any) => {
      if (key === value) {
        this.filterPayLoad.source[key] = false;
      }
      if (this.candidateSource.includes(key)) {
        this.filterPayLoad.source[key] = true;
      }
    });
    // Submission Status

    this.candidate_status.forEach(element => {
      if (element.selected && element.label == value) {
        element.selected = false;
        this.candidate_status[0].selected = false
      }
    });

    // status candaidate avilable
    this.statusCheckboxes.forEach(element => {
      if (element.selected && element.label == value) {
        element.selected = false;
        this.statusCheckboxes[0].selected = false
      }
    });

    // Availability
    this.availablecheckbox.forEach(element => {
      if (element.selected && element.label == value) {
        element.selected = false;
        this.availablecheckbox[0].selected = false
      }
    });


    // Engagement Type
    this.availableForCheckboxes.forEach(element => {
      if (element.selected && element.label == value) {
        element.selected = false;
        this.availableForCheckboxes[0].selected = false
      }
    });

    if(this.tempFilterChanges.workAuthorization){
      this.filterPayLoad.workAuthorization = this.tempFilterChanges.workAuthorization.filter(element => element.selected).map(element => element.label);;
   }

    this.filterPayLoad.availableIn = this.availablecheckbox.filter(element => element.selected).map(element => element.label);;
    this.filterPayLoad.engagementType = this.availableForCheckboxes.filter(element => element.selected).map(element => element.label);
    this.filterPayLoad.status = this.statusCheckboxes.filter(element => element.selected).map(element => element.label);;
    this.filterPayLoad.submissionFilters = this.candidate_status.filter(element => element.selected).map(element => element.label);;


    this.filterPayLoad.searchAfterKey = null;
    this.stopscrollFlag = false;
    let deletingData: any = {}
    deletingData.value = value;
    deletingData.index = index;
    this.jobService.setDataForFilter(deletingData);
    this.filterapicall();
  }

  updateConnectionStatus(candidateData) {
    if(candidateData && this.response.getValue().length > 0) {
      const currentCandidateData = this.response.getValue();
      const updatedCandidateData = currentCandidateData.map(candidate=>
        candidate.createdBy === candidateData.createdBy ? { ...candidate, connectionStatus: candidateData.connectionStatus } : candidate);
      this.response.next(updatedCandidateData);
    }
  }

  // Label msg set .
  checkForEmptyJobList(candidateList, searchAfterKey) {
    if (candidateList && (candidateList.length === 0 || candidateList.length < 10)) {
      this.stopscrollFlag = true;
      this.candidateFoundStatus = "Couldn't find any Candidates for the applied filters."
    } else {
      // this.candidateFoundStatus = "Fetching Candidates...";
      this.stopscrollFlag = false;
      this.checkSearchAfterKey(searchAfterKey);
    }
  }

  checkSearchAfterKey(searchAfterKey) {
    if (searchAfterKey && searchAfterKey[1] != null) {
      this.previousSearchAfterKey = searchAfterKey[1];
      if (searchAfterKey[1] < 0) {
        this.stopscrollFlag = true;
      }
    }
  }

  updateExperienceValues(data) {
    this.value = data.experienceFrom != null ? data.experienceFrom : 0;
    this.highValue = data.experienceTo != null ? data.experienceTo : 0;
    this.value1 = data.postedFrom != null ? data.postedFrom : 0;
    this.highValue1 = data.postedTo != null ? data.postedTo : 0;
  }

  resetFilterPayload(data) {
    this.filterPayLoad = data;
    this.filterPayLoad.searchAfterKey = null;
    this.previousSearchAfterKey = null;
    this.obj.searchAfterKey = null;
    this.stopscrollFlag = false;
    this.showWorkAuthorization = false;
  }





  updateCandidateDetails(data: any, content: any) {

    if (content.for === "CANDIDATE_DETAIL") {
      this.selectedCandidateData = { ...data };
      this.selectedCandidateData.call = false;
      // AUDIT_04 Batch 4 — respect a URL-provided `tabName` so entering
      // `/newcandidates?candidateId=X&tabName=jobsApplied` from the
      // dashboard and then clicking a different candidate in the left
      // list doesn't silently revert to Profile. Same keep-route guard
      // used elsewhere in this file (lines 1109-1112, 1141-1142).
      const keepRouteTab = this.singleCandidateView && !!this.tabName && this.tabName !== 'profileSummary';
      if (!keepRouteTab) this.candidateDetailsTabName = "profileSummary";
      // Switching to a different candidate must reset the details scroll
      // viewport — the shared `.jc-v3-entity-details-body` container sits
      // outside the per-candidate render so its scrollTop persists across
      // candidate swaps otherwise. Smooth-scroll to 0 to match the in-page
      // tab behaviour and avoid landing the new candidate halfway down.
      if (this.designVersion === 'v3') {
        setTimeout(() => {
          const el = document.querySelector('.jc-v3-entity-details-body') as HTMLElement | null;
          if (el) el.scrollTo({ top: 0, behavior: 'smooth' });
        }, 0);
      }
    }
    else if (content.for === "TAB_ROUTE") {
      this.candidateDetailsTabName = data;
      let datas = content.value;
      if (this.isParenActivity(data)) {
        datas.call = true;
      } else {
        datas.call = false;
      }

      this.selectedCandidateData = { ...datas };
      // this.selectedCandidateData = datas;
      // Card stat shortcuts land here with a DIFFERENT candidate but the same
      // tab, so the tab component stays mounted and only refills; the shared
      // `.jc-v3-entity-details-body` keeps its old scrollTop and a smooth
      // scroll gets cancelled by the reload's offset adjustments. Jump
      // instantly (mirror of new-job TAB_ROUTE).
      if (this.designVersion === 'v3') {
        setTimeout(() => {
          const el = document.querySelector('.jc-v3-entity-details-body') as HTMLElement | null;
          if (el) el.scrollTop = 0;
        }, 0);
      }
    }
  }

  isParenActivity(data: string): boolean {
    return data === 'jobsApplied' || data === 'cInvited'
  }

  // Debounce rapid same-tab re-clicks (double-click). Re-minting
  // selectedCandidateData twice in quick succession re-triggered the mounted tab
  // child's ngOnChanges twice, firing two racing list loads that corrupted the
  // pagination cursor and stopped infinite scroll. A deliberate re-click (after
  // the ~500ms double-click window) still reloads + scrolls to top as before.
  private lastTabClickName = '';
  private lastTabClickAt = 0;

  updateCandidatePortfolioDetails(data: string) {
    const now = Date.now();
    if (data === this.lastTabClickName && (now - this.lastTabClickAt) < 500) {
      return;
    }
    this.lastTabClickName = data;
    this.lastTabClickAt = now;
    this.candidateDetailsTabName = data;
    if (!this.isParenActivity(data)) {
      this.selectedCandidateData = { ...this.selectedCandidateData };
      this.selectedCandidateData.call = false;
    } else {
      this.selectedCandidateData = { ...this.selectedCandidateData };
    }
    // Reset the shared V3 scroll container on tab change. Mirror of
    // /newjobs G1 fix in new-job.updateJobPortfolioDetails — the outer
    // `.jc-v3-entity-details-body` sits outside the per-tab `*ngIf`
    // switch, so scroll state persisted across tab swaps until we reset
    // it explicitly here. `setTimeout(0)` gives Angular a tick to swap
    // children so we reset after the new tab has rendered.
    if (this.designVersion === 'v3') {
      setTimeout(() => {
        const el = document.querySelector('.jc-v3-entity-details-body') as HTMLElement | null;
        if (!el) return;
        el.scrollTo({ top: 0, behavior: 'smooth' });
        // Some tabs render their own inner infinite-scroll container inside the
        // details body, so resetting the body alone doesn't move them — reset
        // those to the top as well.
        el.querySelectorAll('[infiniteScroll], .talent-pool-container')
          .forEach((n) => { (n as HTMLElement).scrollTo({ top: 0, behavior: 'smooth' }); });
      }, 0);
    }
  }


  cleanJobSource() {
    this.candidateSource = [...new Set(this.candidateSource)].filter((ele: any) => ele.toLowerCase() !== 'all');
  }

  closeCandidateSupplyModal() {
    this.modalService.hide(1);
  }

  InvitetoApplyFilter() {
    if (this.screenName != undefined && this.screenName === 'job-listing') {
      this.BaseresponseFilter();
      for (let key in this.filterPayLoad.source) {
        if (key == 'myCandidates') {
          this.filterPayLoad.source.myCandidates = true;
          this.filterPayLoad.status = ['Active'];
        } else {
          this.filterPayLoad.source[key] = false;
        }
      }
    }
  }

  openFilterSlider() {
    if (!this.isFilterOpen) {
      this.filterChanges = this.tempFilterChanges;
      console.log("FIlter open" , this.filterChanges);

      this.isFilterOpen = true;
      this.jobService.setSliderToggle(true, 'candidates', null,false);
    }
  }

  closeFilterSlider() {
    if (this.isFilterOpen) {
      this.isFilterOpen = false
      this.jobService.setSliderToggle(false, 'candidates', null,false);
    }
  }

  onStatuChange(value: string | any) {

    // when user filtered the submission filter and trying to route from candidate listing by clicking the count
    if (value && typeof(value) === "string" && value.split("|").length > 0 && value.split("|")[0] === "SUBMISSION_ROUTE") {
      this.candidateDetailsTabName = "jobsApplied";
      const datas = this.response.getValue();

      if (datas) {
        const selectedData = datas.filter((_e: any) => _e.candidateId === value.split("|")[1]);
        console.log("selectedData ", selectedData[0]);
        if (selectedData && selectedData.length > 0) {
          this.selectedCandidateData = selectedData[0];
        }
      }

      return;
    }
    else if(value && value.content === "RESUME_UPLOADED"){
      this.selectedCandidateData = value.data;
    }
    else if(value && value.content === "RELOAD"){
      this.filterPayLoad.candidatesToFilter = value.data.candidateId;
    }
    else if (value && value.content === "STATUS_UPDATED" && value.data) {
      this.selectedCandidateData = { ...value.data };

      const currentData = this.response.getValue();
      if (Array.isArray(currentData) && currentData.length > 0) {
        const updatedData = currentData.map((candidate: any) => {
          if (candidate.candidateId === value.data.candidateId) {
            return { ...candidate, ...value.data };
          }
          return candidate;
        });
        this.response.next(updatedData);
      }
      return;
    }


    this.reloadProcess(value);
    // for now commenting it
    // console.log("CANDIDATE_CHANGE_TRIGGERED " , candidateData);
    // const responseValue : Array<any> =  this.response.getValue();
    // if(Array.isArray(responseValue) && responseValue.length > 0){
    //   let responseData = responseValue.map((element: any)=>{
    //     if(element.candidateId === candidateData.candidateId){
    //       element = candidateData;
    //       this.selectedCandidateData =  element;
    //     }
    //     return element;
    //   });
    //   this.sortDateByNormalCandidate(responseData);
    // }
  }



  emitReceived(value: any) {
    const currentData = this.response.getValue();
    if (value.candidateId == currentData.candidateId) {
      currentData[value.index] = { ...currentData[value.index], status: currentData.status }
    }
  }


  sortDateByNormalCandidate(val: any) {
    let sortedDate = val.sort((a, b) => { return <any>new Date(b.updatedOn) - <any>new Date(a.updatedOn); })
    this.response.next(this.sortFeature(sortedDate));
  }

  sortFeature(data) {
    return data.sort((a, b) => {
      return b.isFeatured - a.isFeatured;
    });
  }


  getsuggjob(data) {
    data.pageNumber = 0;
    data.limit = 10;
    data.userId = localStorage.getItem('userId');
    this.apiService.create("jobs/findSuggestedJobs", data).subscribe((res) => {
      res.componentName = 'SuggestedJobComponent';
      this.showsuggJobsData = res;
      this.pageType.setsuggjob(res)
    })
  }

  onStatusChangeEvent(data: any) { 
    
    if(data) {
      this.stopscrollFlag = false;
      this.filterPayLoad.candidatesToFilter = null;
      this.filterPayLoad = {
        ...this.filterPayLoad,
        searchAfterKey: null,
      }

      if(data.value === 'update'){
        this.filterPayLoad.candidatesToFilter = data.candidate.candidateId;
      }

      this.previousSearchAfterKey = null;
      this.loadCenterSkeleton.next(true);

      this.filterapicall();
    }
  }


  reloadFilter(value: string) {
    this.reloadProcess(value);
  }

  reloadProcess(value: any) {
    this.loadCenterSkeleton.next(true);
    this.filterPayLoad.searchAfterKey = null;
    this.previousSearchAfterKey = null;
    if(value === 'discard'){
      this.filterPayLoad.candidatesToFilter = null;
      this.singleCandidateView = false;
      this.afterCandidateCreated =  false;
    }
    else{
      this.filterPayLoad.candidatesToFilter = value.candidateId;
    }

    if (value === 'updateReload') {
      this.filterPayLoad.status = ['Available'];
      this.statusCheckboxes.forEach(val => val.selected = false);
      this.statusCheckboxes.find(val => val.label === 'Available').selected = true;
      // update only the status without affecting the existing changes
      this.tempFilterChanges = {
        ...this.tempFilterChanges,
        statusCheckedItems: this.statusCheckboxes,
      }
    }

    this.filterapicall();
  }


  getPanelValue(value: any) {
    this.panel = value;
  }

  chatbottom() {
    let seletedItem: any = {};
    seletedItem.owner = true;
    this.messagemodelflag = true;
    seletedItem.userId = localStorage.getItem('userId');
    this.messageData = [];
    seletedItem.groupType = "CANDIDATE";
    seletedItem.messageType = "CANDIDATE";
    seletedItem.id = null;
    // Bottom chat: also load direct USER-to-USER contacts (message/new/contact/{userId})
    // and merge them into the list, same as the Home page bottom chat.
    seletedItem.bottomChat = true;
    this.messageData = seletedItem;


  }

  closeMessage(event) {
    this.messagemodelflag = false;
  }

  countSouce: number = 0;
  streamReloadApicallcandidate() {
    let data: any = JSON.parse(localStorage.getItem('candidateForm'));
    data.searchAfterKey = null;
    this.filterPayLoad = data;
    this.stopscrollFlag = false
    this.response.next([]);
    this.obj.searchAfterKey = null;
    this.previousSearchAfterKey = null;
    this.filterPayLoad.searchAfterKey = null;
    this.filterapicall();
  }

  /**
   * Calculate total count of active filters by checking actual filter arrays
   * @returns number of active filters
   */
  getActiveFilterCount(): number {
    let totalCount = 0;

    // Check available for (engagement) filters
    if (this.availableForCheckboxes && Array.isArray(this.availableForCheckboxes)) {
      totalCount += this.availableForCheckboxes.filter(item => item.selected).length;
    }

    // Check work mode filters
    if (this.workModeCheckboxes && Array.isArray(this.workModeCheckboxes)) {
      totalCount += this.workModeCheckboxes.filter(item => item.selected).length;
    }

    // Check status filters
    if (this.statusCheckboxes && Array.isArray(this.statusCheckboxes)) {
      totalCount += this.statusCheckboxes.filter(item => item.selected).length;
    }

    // Check work authorization filters
    if (this.WACheckboxes && Array.isArray(this.WACheckboxes)) {
      totalCount += this.WACheckboxes.filter(item => item.selected).length;
    }

    // Check available checkbox filters (availability in)
    if (this.availablecheckbox && Array.isArray(this.availablecheckbox)) {
      totalCount += this.availablecheckbox.filter(item => item.selected).length;
    }

    // Check candidate status filters
    if (this.candidate_status && Array.isArray(this.candidate_status)) {
      totalCount += this.candidate_status.filter(item => item.selected).length;
    }

    // Check work mode data if it's different from workModeCheckboxes
    if (this.workModeData && Array.isArray(this.workModeData)) {
      totalCount += this.workModeData.filter(item => item.selected).length;
    }

    // Check personal networks
    if (this.personalNetworks && Array.isArray(this.personalNetworks)) {
      totalCount += this.personalNetworks.length;
    }

    // Check business networks
    if (this.businessNetworks && Array.isArray(this.businessNetworks)) {
      totalCount += this.businessNetworks.length;
    }

    // Check business customers
    if (this.businessCustomers && Array.isArray(this.businessCustomers)) {
      totalCount += this.businessCustomers.length;
    }

    // Check published by users
    if (this.publishedByUsers && Array.isArray(this.publishedByUsers)) {
      totalCount += this.publishedByUsers.length;
    }

    // Check form-based filters if candidateFilterForm exists
    if (this.candidateFilterForm) {
      const formValues = this.candidateFilterForm.getRawValue();

      // Check source filters
      if (formValues.source && Array.isArray(formValues.source)) {
        formValues.source.forEach((sourceGroup: any) => {
          if (sourceGroup) {
            Object.keys(sourceGroup).forEach(key => {
              if (key !== 'All' && sourceGroup[key] === true) {
                totalCount++;
              }
            });
          }
        });
      }

      // Check experience type (if not default)
      if (formValues.experienceType && formValues.experienceType !== 'Any (Years)') {
        totalCount++;
      }

      // Check posted day range (if not default)
      if (formValues.postedDayRange && formValues.postedDayRange !== 'Any (Days)') {
        totalCount++;
      }
    }

    return totalCount;
  }

  // V3 candidate detail header helpers
  private readonly candidateUserTypeMap: { [key: string]: string } = {
    'FREELANCE_RECRUITER': 'Freelance Recruiter',
    'RECRUITER': 'Recruiter',
    'JOB_SEEKER': 'Job Seeker',
    'MANAGEMENT_TALENT_ACQUISITION': 'Manager',
    'MANAGEMENT TALENT ACQUISITION': 'Manager',
    'BENCH_RECRUITER': 'Bench Recruiter'
  };

  formatCandidateUserType(userType: string): string {
    if (!userType) return '';
    return this.candidateUserTypeMap[userType] || userType.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
  }

  getCandidateInitials(): string {
    const fn = (this.selectedCandidateData as any)?.firstName || this.selectedCandidateData?.user?.firstName || '';
    const ln = (this.selectedCandidateData as any)?.lastName || this.selectedCandidateData?.user?.lastName || '';
    return ((fn[0] || '') + (ln[0] || '')).toUpperCase() || '?';
  }

  // Delegates to the shared pastel-hash helper so the V3 detail header avatar
  // matches the left-panel card avatars driven by getColor() in candidates-page.
  getCandidateAvatarColor(): string {
    const fn = (this.selectedCandidateData as any)?.firstName || this.selectedCandidateData?.user?.firstName || '';
    const ln = (this.selectedCandidateData as any)?.lastName || this.selectedCandidateData?.user?.lastName || '';
    return this.jobService.getColor(`${fn} ${ln}`.trim());
  }

  // Same-hue dark text derived from the same hash as getCandidateAvatarColor().
  getCandidateAvatarTextColor(): string {
    const fn = (this.selectedCandidateData as any)?.firstName || this.selectedCandidateData?.user?.firstName || '';
    const ln = (this.selectedCandidateData as any)?.lastName || this.selectedCandidateData?.user?.lastName || '';
    return this.jobService.getFullnameTextColor(`${fn} ${ln}`.trim());
  }

  // ──────────────────────────────────────────────────────────────────
  // Candidate-OWNER (the recruiter who created/posted the candidate)
  // helpers — drive the small avatar + name + role · org block on the
  // right side of the V3 detail header. Source priority matches the V2
  // candidate-profile-summary + connection-template `candidate-profile-1`
  // pattern: prefer the rich `user` record (fullname / photo / userType
  // / workExperience), fall back to the top-level `createdByUserName`
  // string when the user record is absent.
  // ──────────────────────────────────────────────────────────────────
  // Logo of the business the candidate is posted on behalf of, taken from
  // the owner's workExperience entry for that business — not
  // workExperience[0], which may be an older company with no logo. The
  // first tier that matches any entry decides; null keeps the briefcase.
  getCandidateBusinessLogo(): string | null {
    const cand: any = this.selectedCandidateData || {};
    // candidates/filter resolves the logo from the business index; prefer it.
    if (cand.businessLogo && cand.businessLogo !== 'null') {
      return cand.businessLogo.startsWith('http') ? cand.businessLogo : this.url + cand.businessLogo;
    }
    const wxp: any[] = cand.user?.workExperience || [];
    const behalfOf = (cand.postedBehalfOf || '').trim().toLowerCase();
    const tiers: Array<(exp: any) => boolean> = [
      exp => !!cand.businessId && exp?.businessId === cand.businessId,
      exp => !!cand.organisationId && exp?.organisationId === cand.organisationId,
      exp => !!behalfOf && (exp?.organisationName || '').trim().toLowerCase() === behalfOf,
      exp => !!exp?.currentOrganization
    ];
    for (const matches of tiers) {
      const hits = wxp.filter(matches);
      if (hits.length) {
        const logo = hits.find(exp => exp?.businessLogo && exp.businessLogo !== 'null')?.businessLogo;
        return logo ? (logo.startsWith('http') ? logo : this.url + logo) : null;
      }
    }
    return null;
  }

  private getOwnerName(): string {
    return this.selectedCandidateData?.user?.fullname
        || this.selectedCandidateData?.createdByUserName
        || '';
  }

  getOwnerInitials(): string {
    const name = this.getOwnerName();
    const parts = name.trim().split(/\s+/);
    const first = parts[0]?.[0] || '';
    const last = parts.length > 1 ? parts[parts.length - 1][0] : '';
    return (first + last).toUpperCase() || '?';
  }

  getOwnerAvatarColor(): string {
    return this.jobService.getColor(this.getOwnerName().trim());
  }

  getOwnerAvatarTextColor(): string {
    return this.jobService.getFullnameTextColor(this.getOwnerName().trim());
  }

  formatLocation(city: string, state: string, country: string): string {
    return this.gigsumoService.formatLocation(city, state, country);
  }

  getCurrency(country: string): string {
    switch (country) {
      case 'US': return 'USD';
      case 'IN': return 'INR';
      case 'CA': return 'CAD';
      case 'AU': return 'AUD';
      default: return 'CUR';
    }
  }

  getPayType(payType: string): string {
    switch (payType) {
      case 'Hourly': return 'Hr';
      case 'Daily': return 'Day';
      case 'Weekly': return 'Week';
      case 'Monthly': return 'Month';
      case 'Yearly': return 'Year';
      default: return payType || '';
    }
  }

  // Delegate action-button calls to the profile-summary child component
  inviteSelectedCandidate() { this.profileSummaryRef?.triggerInvite(); }
  editSelectedCandidate() { this.profileSummaryRef?.triggerEdit(); }
  enableSelectedCandidate(event: any) { this.profileSummaryRef?.triggerEnableCandidate(event); }
  uploadResumeForCandidate() { this.profileSummaryRef?.triggerUploadResume(); }

  // Handle detail header "More" dropdown toggle to coordinate with candidate card dropdowns
  onDetailHeaderDropdownToggle(open: boolean) {
    this.openDetailHeaderDropdown = open;
    if (open) {
      // Notify candidates-page to close its dropdowns
      this.searchData.setDropdownState('detail-header', true);
    } else {
      this.searchData.setDropdownState('detail-header', false);
    }
    this.cdr.detectChanges();
  }

  // Republish / Upgrade / Downgrade — mirror new-job.component.ts:1910-1926.
  // The handlers live on candidates-page; we delegate so the detail header
  // shares the same plan-check, swal confirmation, and FormData PUT flow
  // as the candidate-card More menu — no duplicated logic.
  republishSelectedCandidate() {
    if (this.candidatesRef && this.selectedCandidateData) {
      this.candidatesRef.republishCandidate(this.selectedCandidateData);
    }
  }
  upgradeSelectedCandidate() {
    if (this.candidatesRef && this.selectedCandidateData) {
      this.candidatesRef.upgradeCandidate(this.selectedCandidateData);
    }
  }
  downgradeSelectedCandidate() {
    if (this.candidatesRef && this.selectedCandidateData) {
      this.candidatesRef.downgradeCandidate(this.selectedCandidateData);
    }
  }

  // AUDIT_04 Batch 4 — Urgent/Hot badge countdown for the V3 detail
  // header. Ported verbatim from candidates-page.component.ts:2164 so
  // the detail header badge uses the same feature-consumption math as
  // the left-panel card.
  getActiveUrgencyDays(candidate: any): number | null {
    if (!candidate?.isFeatured) return null;

    const now = new Date();
    let urgencyEndDate: Date;

    if (candidate?.featuredConsumptions?.length > 0) {
      const lastConsumption = candidate.featuredConsumptions[candidate.featuredConsumptions.length - 1];
      const fromDate = new Date(lastConsumption.fromDate);
      const dayCount = lastConsumption.dayCount || 1;
      urgencyEndDate = new Date(fromDate.getTime() + (dayCount * 24 * 60 * 60 * 1000));
    } else if (candidate?.featuredUpdatedOn) {
      const featuredDate = new Date(candidate.featuredUpdatedOn);
      urgencyEndDate = new Date(featuredDate.getTime() + (2 * 24 * 60 * 60 * 1000));
    } else {
      return 1;
    }

    const diffMs = urgencyEndDate.getTime() - now.getTime();
    const days = Math.ceil(diffMs / (1000 * 60 * 60 * 24));
    return days > 0 ? days : 1;
  }

}

